import yesNo from './yesNo'

export default yesNo
